/** Безопасная работа с localStorage: приватный режим/отключённые cookies
 *  бросают SecurityError — не даём упасть провайдерам при старте приложения. */
export const getStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setStorage = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Хранилище недоступно — авторизация/язык останутся в памяти сессии.
  }
};

export const removeStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Хранилище недоступно — ничего чистить не требуется.
  }
};